export default __webpack_public_path__ + "static/media/traindex-logo.d77037db.png";